const copy = {
  undefined: {
    flavor: 'TAP STARS TO RATE',
    label: '',
    placeholder: '',
  },
  1: {
    flavor: 'worst ever',
    label: 'SO SORRY, HOW CAN WE IMPROVE?',
    placeholder: 'Comments',
    thanksMessage:
      'Thank you for the thoughtful feedback. We have passed it along to the clinic staff.',
  },
  2: {
    flavor: 'not good',
    label: 'HOW CAN WE IMPROVE?',
    placeholder: 'Comments',
    thanksMessage:
      'Thank you for the thoughtful feedback. We have passed it along to the clinic staff.',
  },
  3: {
    flavor: 'just ok',
    label: 'HOW CAN WE IMPROVE?',
    placeholder: 'Comments',
    thanksMessage:
      'Thank you for the thoughtful feedback. We have passed it along to the clinic staff.',
  },
  4: {
    flavor: 'I liked it',
    label: 'THANKS! WHAT DID YOU LIKE?',
    placeholder: 'Describe your experience',
    thanksMessage:
      'Thank you for the thoughtful feedback. We have passed it along to the clinic staff.',
  },
  5: {
    flavor: 'It was great!',
    label: 'THANKS! WHAT MADE IT SO GREAT?',
    placeholder: 'Describe your experience',
    thanksMessage: 'Thanks for your feedback',
  },
};
export { copy };
